module.exports = __webpack_public_path__ + "images/notification4942b1f6bf632ebd0a336b30f0e2ec3b.svg";